import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Grid, IconButton } from '@mui/material';
import MobileStepper from '@mui/material/MobileStepper';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

function Slider({ images }: { images: { id: number | string; file: string }[] }) {
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = images.length;

    const handleBack = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep === 0 ? maxSteps - 1 : prevActiveStep - 1));
    };

    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <IconButton onClick={handleNext}>
                    <ArrowBackIosIcon />
                </IconButton>
                <AutoPlaySwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={activeStep}
                    onChangeIndex={handleStepChange}
                    enableMouseEvents
                    interval={4000}
                >
                    {images.map(({ id, file }) => {
                        return (
                            <Grid container justifyContent='center' key={id}>
                                <Grid item>
                                    <Box
                                        component='img'
                                        sx={{
                                            height: { xs: '100%', md: 300 },
                                            maxWidth: 300,
                                            overflow: 'hidden',
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                        }}
                                        src={file}
                                        alt={'weed'}
                                    />
                                </Grid>
                            </Grid>
                        );
                    })}
                </AutoPlaySwipeableViews>
                <IconButton onClick={handleBack}>
                    <ArrowForwardIosIcon />
                </IconButton>
            </Box>
            <MobileStepper
                steps={maxSteps}
                position='static'
                activeStep={activeStep}
                sx={{
                    mt: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            />
        </Box>
    );
}

export default Slider;
